namespace advisorop.components.servicer {


    class CuCompanyGroupController {
        $router;
        onUpdateCompanyGroup: any;
        onCreateCompanyGroup: any;
        companyGroupId: number;

        selCompanyGroup: domains.IXXCompanyGroup;
        model: domains.IXXCompanyGroup;

        isInEditState: boolean = false;

        constructor(private servicerService: services.ServicerService) {
        }


        createCompanyGroup(): void {
            this.servicerService.createCompanyGroup(this.model)
                .then(data => {

                    this.model = data.data;
                    toastr.success("Company group created.");

                    this.onCreateCompanyGroup({ companyGroup: this.model });

                })
                .catch(err => { toastr.error("Cannot create company group."); });
        }
      

        updateCompanyGroup(): void {
            this.servicerService.updateCompanyGroup(this.model)
                .then(data => {
                    this.model = data.data;
                    toastr.success("Company group updated.");
                    this.onUpdateCompanyGroup({ companyGroup: this.model });

                })
                .catch(err => { toastr.error("Cannot update company group."); });
        }


        loadCompanyGroupData(companyId: number): void {
            this.servicerService.getCompanyGroup(companyId)
                .then(data => {
                    this.model = data.data;
                })
                .catch(err => { toastr.error("Cannot fetch company group.") })
        }

        createEvent: boolean = false;

        $onInit(): void {

        };

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "companyGroupId") {
                    if (this.companyGroupId > 0) {
                        this.loadCompanyGroupData(this.companyGroupId);
                    }
                }
                if (key === "createEvent") {
                    this.createEvent = this.createEvent;
                }
                
            }
        }

    }

    class CuCompanyGroup implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                "router": "<",
                companyGroupId: "<",
                onUpdateCompanyGroup: "&",
                onCreateCompanyGroup: "&",
                createEvent: "<"
            };
            this.controller = ["servicerService", CuCompanyGroupController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/cu-company-group.html';
        }
    }
    angular.module(Constants.APP).component("cuCompanyGroup", new CuCompanyGroup());
}